var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { DES_EVO_TENANT_TOKEN, DES_EVO_USER_TOKEN, getConfig, translate } from "@jti/fe-common";
import { getUser } from "../../utils";
import { Rest } from "../Rest";
export class CouponsApi extends Rest {
    constructor(baseUrl, tenantToken) {
        super(baseUrl);
        this.name = "CouponsApi";
        this.tenantToken = tenantToken;
        this.setCommonHeader(DES_EVO_TENANT_TOKEN, this.tenantToken);
    }
    static init() {
        const config = getConfig();
        if (!CouponsApi.instance) {
            CouponsApi.instance = new CouponsApi(config.CAS_URL, config.CAS_X_DES_AK_TENANT_TOKEN);
        }
        return CouponsApi.instance;
    }
    getProviders(country) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `/coupons/external/providers/${country}`;
            const options = {
                method: "GET",
            };
            try {
                return yield this.request(url, options);
            }
            catch (error) {
                const apiError = error;
                const errorMessage = (apiError === null || apiError === void 0 ? void 0 : apiError.message) || translate("libs.ui.promotion.error_fetching_providers");
                throw new Error(errorMessage);
            }
        });
    }
    requestCoupon(code) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const user = getUser();
            const url = `/coupons/external/providers/${code}/request`;
            const options = {
                method: "POST",
                headers: {
                    [DES_EVO_USER_TOKEN]: user.ciam_token,
                },
            };
            try {
                return yield this.request(url, options, true);
            }
            catch (error) {
                const apiError = error;
                const errorMessage = (_c = (_a = apiError === null || apiError === void 0 ? void 0 : apiError.message) !== null && _a !== void 0 ? _a : (_b = apiError === null || apiError === void 0 ? void 0 : apiError.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : translate("libs.ui.promotion.error_requesting_coupon");
                throw new Error(errorMessage);
            }
        });
    }
}
CouponsApi.instance = null;
//# sourceMappingURL=CouponsApi.js.map